<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >辅助功能&内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/KnowledgeIndex/kManageIndex' }"
          >知识付费内容管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>内容视频链接</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <div @click="handleGo('', 'kVideoDetail')">
            <p class="flex-rowl"><i class="iconfont icon-xinzeng"></i> 新增</p>
          </div>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="searchTxt"
              placeholder="输入关键字查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-between">
              <div class="content_wrap flex-between">
                <div class="pic_box" v-if="item.videourl">
                  <video :src="item.videourl" controls></video>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      知识产权标题：<span>{{ item.kpidstr }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p>
                      创建时间：<span>{{ item.addtime | formatDate }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="editBtn" @click="handleGo(item.id, 'kVideoDetail')">
                编辑视频→
              </div>
            </div>
          </div>
        </template>

        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getKonwledgeVideoList } from "../../../api/knowledge";
import { mapState } from "vuex";
export default {
  name: "kTypeList",
  data() {
    return {
      loading: false,
      searchTxt: "",
      listTotal: 0,
      dataList: [],
      params: {
        kpid: "",
        keyword: "",
      },
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.kpid = id;
        this.initData();
      } else {
        this.$router.back();
      }
    },

    initData() {
      this.loading = true;
      getKonwledgeVideoList(this.params).then((res) => {
        this.listTotal = res.total;
        this.dataList = res.list;
        this.loading = false;
      });
    },
    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.initData();
    },
    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },
    // 重置
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.initData();
    },

    handleReturn() {
      history.back();
    },

    handleGo(id, name) {
      let { kpid } = this.params;
      this.encryptstringadd(name, { id, kpid });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .list_wrap {
    height: 57vh;
    .item_main_wrap {
      align-items: center;
      .icon-zanwutupian1 {
        font-size: 40px;
      }
      .pic_box {
        width: 80px;
        height: 80px;
        video {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>